import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CampusService } from '@core-app/services/campus.service';
import { ClientService } from '@core-app/services/client.service';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { Subscription } from 'rxjs';

@Component({
  selector: 'core-campus-select',
  templateUrl: './campus-select.component.html',
  styleUrl: './campus-select.component.scss',
  standalone: false,
  providers: [
    {
      provide: BsDropdownConfig,
      useValue: { isAnimated: false, autoClose: true },
    },
  ],
})
export class CampusSelectComponent implements OnInit, OnDestroy {
  client = inject(ClientService);
  campusService = inject(CampusService);
  protected router = inject(Router);
  protected breakpoint = inject(BreakpointObserver);

  campuses: { name: string; id: number | undefined }[] = [];
  selectedCampusId: number | null = null;
  private subscription: Subscription = new Subscription();
  isLargeBreakpoint!: boolean;

  ngOnInit(): void {
    this.campuses = this.campusService.getEnabledCampuses().map(campus => ({
      name: campus.name,
      id: campus.id,
    }));

    // Initialize the selected campus from the CampusService
    this.selectedCampusId = this.campusService.selectedCampus;

    // Subscribe to changes in the selected campus
    this.subscription.add(
      this.campusService.selectedCampus$.subscribe(campusId => {
        this.selectedCampusId = campusId;
      }),
    );

    this.breakpoint.observe(['(min-width: 993px)']).subscribe(result => {
      this.isLargeBreakpoint = result.matches;
    });
  }

  /**
   * Handle campus selection from radio buttons
   * @param campusId The ID of the selected campus
   */
  onCampusRadioChange(campusId: number | undefined): void {
    if (campusId === undefined) {
      return;
    }
    this.campusService.setSelectedCampus(campusId);
  }

  /**
   * Get the name of the currently selected campus
   * @returns The name of the currently selected campus
   */
  getSelectedCampusName(): string {
    const selectedCampus = this.campuses.find(campus => campus.id === this.selectedCampusId);
    return selectedCampus ? selectedCampus.name : 'Select Campus';
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    this.subscription.unsubscribe();
  }
}
